<template>
    <div>
        <section class="jumbotron text-center">
            <div class="container">
                <h1 class="jumbotron-heading">Hello {{firstname}}</h1>
                <p class="lead text-muted">You have successfully signed in with Cognito User Pools.</p>
            </div>
        </section>
        <section>
            <b-card title="Profile">
                <code>
                    <pre>{{profile}}</pre>
                </code>

                <h6>Access Token</h6>
                <code>
                    <pre>{{accessToken}}</pre>
                </code>

                <h6>ID Token</h6>
                <code>
                    <pre>{{idToken}}</pre>
                </code>

                <h6>Refresh Token</h6>
                <code>
                    <pre>{{refreshToken}}</pre>
                </code>
                
                <h6>Current account</h6>
                <code>
                    <pre>{{current}}</pre>
                </code>
                <h6>Current env</h6>
                <code>
                    <pre>{{environment}}</pre>
                </code>
            </b-card>
        </section>
        <section>
            <b-card title="Accounts">
                 <router-view name="accountslist"/>
            </b-card>
        </section>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "home",
    data: function() {
        return {
            response: "unknown"
        };
    },
    computed: {
        accessToken() {
            return this.$store.getters.accessToken;
        },
        refreshToken() {
            return this.$store.getters.refreshToken;
        },
        idToken() {
            return this.$store.getters.idToken;
        },
        profile() {
            return this.$store.getters.profile;
        },
        current() {
            return this.$store.getters.accountId;
        },
        environment() {
            return this.$store.getters.environment;
        },
        firstname() {
            if (this.$store.getters.profile) {
            	return this.$store.getters.profile["cognito:username"].split(" ")[0];
            } else {
            	return null;
            }
        }
    },
    created() {
    }
};
</script>
